import type { Source } from '@jwp/ott-common/types/playlist';

/** JW feeds often ship HLS with FairPlay only and DASH with Widevine — picking HLS first breaks Chrome. */
export function isSafariLike(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/i.test(ua)) return true;
  if (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1) return true;
  return /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
}

export function pickPlayableSource(sources: Source[]): Source | null {
  if (!sources.length) return null;
  const hls = sources.find(
    (s) => s.file.includes('.m3u8') || s.type === 'application/vnd.apple.mpegurl' || s.type?.includes('mpegurl'),
  );
  const dash = sources.find((s) => s.file.includes('.mpd') || s.type?.includes('dash'));
  const withWidevine = sources.find((s) => s.drm?.widevine?.url);
  const withFairPlay = sources.find((s) => s.drm?.fairplay?.processSpcUrl);

  if (isSafariLike()) {
    return withFairPlay ?? hls ?? dash ?? sources[0];
  }
  return withWidevine ?? dash ?? withFairPlay ?? hls ?? sources[0];
}
